const firebaseConfig = {
  apiKey: "AIzaSyB6OUlQECDOqZsUfezgL1TYZr62MVCWu6o",
  authDomain: "emarket-e50a7.firebaseapp.com",
  projectId: "emarket-e50a7",
  storageBucket: "emarket-e50a7.appspot.com",
  messagingSenderId: "965138633396",
  appId: "1:965138633396:web:f8f8ff8393f70fed66fde1"
};


export default firebaseConfig;